import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from 'react';
const barWidth = 3;
const barSpacing = 2;
const barColor = '#1976d2';
const barHeight = 32;
const minBar = 4;
const minDot = 2;
const defaultAmplify = 0.5;
const visibleBars = 140;
const overflowBars = 20;
function amplifyLevel(level, height, amplify) {
    if (level < 0.05)
        return minDot / height;
    return minBar / height + (1 - minBar / height) * (level ** amplify);
}
const VoiceWaveAnimation = ({ height = barHeight, color = barColor, levels, animated = false, amplify = defaultAmplify, speedPxPerSec = 96, }) => {
    const [offset, setOffset] = useState(0);
    const lastTimestamp = useRef(null);
    useEffect(() => {
        if (!animated && levels && levels.length > visibleBars) {
            let running = true;
            const step = (ts) => {
                if (!running)
                    return;
                if (lastTimestamp.current == null)
                    lastTimestamp.current = ts;
                const dt = (ts - lastTimestamp.current) / 1000;
                lastTimestamp.current = ts;
                setOffset((prev) => {
                    let next = prev + speedPxPerSec * dt;
                    const maxOffset = (barWidth + barSpacing);
                    if (next > maxOffset)
                        next -= maxOffset;
                    return next;
                });
                requestAnimationFrame(step);
            };
            const raf = requestAnimationFrame(step);
            return () => {
                running = false;
                lastTimestamp.current = null;
                cancelAnimationFrame(raf);
            };
        }
        return undefined;
    }, [animated, levels, speedPxPerSec]);
    let bars = [];
    if (animated) {
        bars = Array.from({ length: visibleBars + overflowBars }, (_, i) => 0.2 + 0.1 * Math.sin(i));
    }
    else if (levels && levels.length > 0) {
        const totalBars = visibleBars + overflowBars;
        bars = levels.slice(-totalBars);
        if (bars.length < totalBars) {
            bars = [
                ...Array(totalBars - bars.length).fill(0),
                ...bars,
            ];
        }
    }
    else {
        bars = Array(visibleBars + overflowBars).fill(0);
    }
    const centerY = height / 2;
    const xOffset = -offset;
    return (_jsxs("svg", { width: "100%", height: height, viewBox: `0 0 ${(barWidth + barSpacing) * visibleBars - barSpacing} ${height}`, style: { display: 'block', overflow: 'hidden' }, children: [_jsx("g", { transform: `translate(${xOffset},0)`, children: bars.map((level, i) => {
                    const amp = amplifyLevel(level, height, amplify);
                    const barH = Math.max(minDot, amp * height);
                    const y = centerY - barH / 2;
                    const key = `bar-${i}-${Math.round(level * 1000)}`;
                    return (_jsxs(React.Fragment, { children: [_jsx("rect", { x: i * (barWidth + barSpacing), y: y, width: barWidth, height: barH, rx: barWidth / 2, fill: color }), _jsx("rect", { x: i * (barWidth + barSpacing), y: centerY + (centerY - y - barH), width: barWidth, height: barH, rx: barWidth / 2, fill: color })] }, key));
                }) }), animated && (_jsx("style", { children: `
          @keyframes voice-wave-bounce {
            0%, 100% { height: ${minBar}px; y: ${centerY - minBar / 2}px; }
            50% { height: ${height}px; y: 0px; }
          }
          ` }))] }));
};
VoiceWaveAnimation.defaultProps = {
    height: barHeight,
    color: barColor,
    levels: undefined,
    animated: false,
    amplify: defaultAmplify,
    speedPxPerSec: 96,
};
export default VoiceWaveAnimation;
//# sourceMappingURL=VoiceWaveAnimation.js.map